// WI#87721 : Use FolderName constants in mail code
/**
 * folderName which is used for folderNameToId mapping of inbox
 */
export const INBOX_FOLDER_NAME = 'inbox';

/**
 * folderName which is used for folderNameToId mapping for "all folders"
 */
export const MSG_FOLDER_ROOT = 'msgfolderroot';
